import React, {useEffect, useState} from 'react'
import { TabList } from './styles'
import { CategoryAction } from '../../store/action/category'
import {CategoryInterface} from '../../layout/default/types'

interface TabProps {
  tabList: any[]
  handleChange: (i: number) => void
}

const Tab = ({tabList, handleChange}: TabProps) => {

  const [activeTab, setActiveTab] = useState(0)
  const {getCategoryList} = CategoryAction()
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10
  })

  const handleClick = (i: number) => {
    setActiveTab(i)
    handleChange(i)
  }

  const [categoryList, setCategoryList] = useState<CategoryInterface[]>([])

  useEffect(() => {
     getCategoryList(pagination)
      .then((res) => {
        setCategoryList(res.data)
        setActiveTab(res.data[0].id)
        handleChange(res.data[0].id)
      })
  }, [])

  return (
    <TabList>
      <ul>
        {
          categoryList.map((tab, index) => {
          // tabList.map((tab, index) => {
            return (
              <li key={tab.id}>
                <button
                  type='button'
                  onClick={() => handleClick(tab.id)}
                  className={tab.id === activeTab ? 'active' : ''}
                //>{tab}</button>
                >{tab.name}</button>
              </li>
            )
          })
        }
      </ul>
    </TabList>
  )
}

export default Tab
